import { createContext, useContext } from "react"

export type SidebarContextProps = {
  isMini?: boolean
  setIsMini(isMini: boolean): void
}

export const SidebarContext = createContext<SidebarContextProps>({
  isMini: false,
  setIsMini() {},
})

function useSidebarContext() {
  const context = useContext(SidebarContext)
  if (!context) {
    throw new Error(
      "Sidebar compound components cannot be rendered outside the Sidebar component",
    )
  }
  return context
}

export default useSidebarContext
